import { Store } from '@ngrx/store';
import { TrInputComponent } from './../tr-input/tr-input.component';
import { Component } from '@angular/core';
import { AppState } from '../../../interfaces/app-state.interface';
@Component({
    selector: "tr-password",
    templateUrl: "./tr-password.component.html",
    styleUrls: ["./tr-password.component.scss"],
})
export class TrPasswordComponent extends TrInputComponent {
    constructor(store: Store<AppState>) {
        super(store);
    }

    hided: boolean = true;

    hide() {
        this.hided = !this.hided;
    }
}
